import React from "react";
import { Table } from "react-bootstrap";
import { EndpointsRow } from "./EndpointsRow";
import { ApiEndpointI } from "../listaEndpointsPlanes";

interface Props {
  elementos: ApiEndpointI[];
}

export const EndpointsTable = ({ elementos }: Props) => {
  return (
    <Table striped bordered className="table-container">
      <thead>
        <tr className="table-heading">
          <th>Tipo de API</th>
          <th style={{ maxWidth: "50px", textAlign: "center" }}>Consultar</th>
          <th style={{ maxWidth: "50px", textAlign: "center" }}>Descargar</th>
        </tr>
      </thead>
      <tbody>
        {elementos.map((ctEl) => (
          <EndpointsRow key={ctEl.titulo} elemento={ctEl} />
        ))}
      </tbody>
    </Table>
  );
};
